import request from "@/utils/request";

export function getColumn() {
  return request({
    url: "/home/column",
    method: "get",
  });
}

export function getIndex() {
  return request({
    url: "/home/index",
    method: "get",
  });
}

export function getFooter() {
  return request({
    url: "/home/foot",
    method: "get",
  });
}

export function getList(id, query) {
  return request({
    url: `/home/list/${id}`,
    method: "get",
    params: query,
  });
}

export function getListView(id) {
  return request({
    url: `/home/listView/${id}`,
    method: "get",
  });
}

export function getPage(id) {
  return request({
    url: `/home/page/${id}`,
    method: "get",
  });
}
